import router from "../router/index"
import commonParam from "../param/commonParam";
import { getData, setData, clearData } from "../store/storeUtil";
import { REFRESH_TOKEN, TOKEN, TOKEN_TIME } from "../store/method_param";
import { Message } from 'element-ui';
import jq from 'jquery';
const refreshTokenUrl = commonParam.serverUrl + "uaa/authLogin";

export function getToken() {
  let token = getTokenAsync();
  return token;
}

function getTokenAsync() {
  let tokenTime = getData(TOKEN_TIME);
  let nowTime = new Date().getTime();
  let token = getData(TOKEN);
  let timeOut = false
  if (token) {
    // 验证当前token是否需要刷新
    let needRefresh = false;
    if (tokenTime) {
      tokenTime = new Date(tokenTime);
      let timePeriod = nowTime - tokenTime;
      if (timePeriod > commonParam.tokenOverdueTime && timePeriod < commonParam.refreshTokenOverdueTime) {
        needRefresh = true;
        timeOut = false
      }
      if (timePeriod > commonParam.refreshTokenOverdueTime) {
        needRefresh = false
        timeOut = true
      }
    } else {
      timeOut = true
    }
    //timeOut = true;
    // 
    if (timeOut) {
      Message.warning({ message: '登录信息已失效，请重新登录！' });
      clearData();
      location.href = "/";
      // router.replace({
      //   path: '/login',
      //   name: 'Login',
      // });
      // MessageBox.confirm('登录信息已失效，请重新登录！', '提示', {
      //   showClose: false,
      //   closeOnClickModal: false,
      //   closeOnPressEscape: false,
      //   showCancelButton: false,
      //   type: 'warning'
      // }).then(() => {
      //   clearData();
      //   router.replace({
      //     path: '/login',
      //     name: 'Login',
      //   });
      // }).catch(() => { });
    }
    // 
    if (needRefresh && !timeOut) {
      // 刷新token
      let tokenInfo = refreshToken();
      if (tokenInfo.token) {
        setData(TOKEN, tokenInfo.token);
        setData(REFRESH_TOKEN, tokenInfo.refreshToken);
        setData(TOKEN_TIME, new Date().getTime());
        return tokenInfo.token;
      } else {
        clearData();
        return null;
      }
    }
  }

  return token;
}

function refreshToken() {
  let dataInfo = { "grant_type": "refresh_token", "refresh_token": getData(REFRESH_TOKEN) }
  let tokenInfo = {};
  jq.ajax({
    async: false,
    type: "post",
    url: refreshTokenUrl,
    contentType: "application/json;charset=UTF-8",
    data: JSON.stringify(dataInfo),
    success: function (resp) {
      if (resp.result) {
        tokenInfo.token = resp.data.access_token;
        tokenInfo.refreshToken = resp.data.refresh_token;
      }
    }
  });
  return tokenInfo;
  // ax({
  //   url: refreshTokenUrl,
  //   method: "post",
  //   data: dataInfo
  // }).then(resp => {
  //   let accessToken = resp.data.access_token;
  //   if (accessToken) {
  //     console.log(accessToken, '++++++++++++++++++++++++++++++');
  //     setData(TOKEN, accessToken);
  //     setData(REFRESH_TOKEN, resp.data.refresh_token);
  //     setData(TOKEN_TIME, new Date());
  //   }
  // })
}
